import { render, staticRenderFns } from "./my-loans.vue?vue&type=template&id=0053ff90"
import script from "./my-loans.vue?vue&type=script&lang=js"
export * from "./my-loans.vue?vue&type=script&lang=js"
import style0 from "./my-loans.vue?vue&type=style&index=0&id=0053ff90&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports